import { render, staticRenderFns } from "./scenario-compare-table-overview.vue?vue&type=template&id=2b15e64a&scoped=true"
import script from "./scenario-compare-table-overview.vue?vue&type=script&lang=ts"
export * from "./scenario-compare-table-overview.vue?vue&type=script&lang=ts"
import style0 from "./scenario-compare-table-overview.vue?vue&type=style&index=0&id=2b15e64a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b15e64a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b15e64a')) {
      api.createRecord('2b15e64a', component.options)
    } else {
      api.reload('2b15e64a', component.options)
    }
    module.hot.accept("./scenario-compare-table-overview.vue?vue&type=template&id=2b15e64a&scoped=true", function () {
      api.rerender('2b15e64a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/results/scenario-compare/sections/scenario-compare-table-overview.vue"
export default component.exports